<template>
  <div>
    <div class="underline">
      <span>
        <button v-if="this.value > 0" class="btn btn-on btn-sm" @click.stop="updateValue(0)">T</button>
        <button v-else class="btn btn-off btn-sm" @click.stop="updateValue(1)">T</button>

        <button v-if="this.value > 1" class="btn btn-on btn-sm" @click.stop="updateValue(1)">E</button>
        <button v-else class="btn btn-off btn-sm" @click.stop="updateValue(2)">E</button>

        <button v-if="this.value > 2" class="btn btn-on btn-sm" @click.stop="updateValue(2)">M</button>
        <button v-else class="btn btn-off btn-sm" @click.stop="updateValue(3)">M</button>

        <button v-if="this.value > 3" class="btn btn-on btn-sm" @click.stop="updateValue(3)">L</button>
        <button v-else class="btn btn-off btn-sm" @click.stop="updateValue(4)">L</button>
      </span>
    </div>
    <under-label :id="'checkbox-' + this._uid">
      <slot></slot>
    </under-label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-checkbox",
  components: {
    UnderLabel
  },
  props: ["value", "disabled", "disableAutoSave"],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateValue(value) {
      if (this.canEdit) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value() {
      if (!this.disableAutoSave) {
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.underline {
  border-bottom: solid 1px $gray-200;
  font-size: 1.25em;
  font-weight: bold;
  line-height: 1.35em;
  min-height: 1.4em;
  color: $gray-600;
}
label {
  cursor: auto;
  font-size: 0.75em;
  font-weight: bold;
  margin-bottom: 0.25em;
}
.btn-sm {
  padding: 0;
  padding-top: 0.125em;
  font-size: 0.875rem;
  line-height: 1em;
  width: 21px;
  height: 21px;
}
</style>
